module.exports = __webpack_public_path__ + "img/rascrut-9.578e3555.webp";